import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Title } from "../../components/NewTitle";
import { Link } from "../../components/LinkIcon";
import { CustomerData } from "./CustomerData";
export const CustomerCompany = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  return (
    <section>
      <div className="customer-company-warp">
        <div className="inner">
          <Title title={t("customer.home.cardList.title")} />
          <div className="company-card-warp">
            {CustomerData.map((item) => (
              <div
                className="story-card"
                onClick={() => {
                  nav(item.url);
                }}
              >
                <div className="card-img-bg">
                  <img src={item.imgbgUrl} alt={item.alt} />
                </div>
                <div className="card-logo">
                  <img src={item.imgUrl} alt="authing logo" />
                </div>
                <div className="card-quote">{t(item.cardQuote)}</div>
                <div className="card-link">
                  <Link href={item.url}>{t("common.common-story")}</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
